module.exports = __webpack_public_path__ + "img/notebook.a26a0150.svg";